import PrivateRoute from './PrivateRoute';
export default PrivateRoute;



// WEBPACK FOOTER //
// ./src/components/PrivateRoute/index.js